import { makeStyles } from "@material-ui/core/styles";
import withLoader from "../../../components/layouts/WithLoader";
import { useNavigate } from "react-router-dom";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { useEffect, useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import Select from "react-select";

import makeAnimated from "react-select/animated";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

import UtilsFormule from "../../../utils/UtilsFormule";
import DataListProductDetails from "./DataListProductDetails";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));
const menuAboveFileStyles = {
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};
function getSteps() {
  return [
    "Choisir le dépôt et le fichier excel de l'inventaire",
    "Verifier les produits et les quatités et confirmer"
  ];
}



const AddInventaire = ({ startLoading, stopLoading }) => {
  const classes = useStyles();
  const steps = getSteps();
  const animatedComponents = makeAnimated();
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();

  const [allWarehouses, setAllWarehouses] = useState([]);
  const [inventaireWarehouse, setInventaireWarehouse] = useState();
  const [inventaireProducts, setInventaireProducts] = useState([]);

  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState();
  const [selectedOption, setSelectedOption] = useState(null);

  const [warehouseId, setWarehouseId] = useState(0);
  const [warehouseSelectedOption, setWarehouseSelectedOption] = useState(null);
  const [inventoryFile, setInventoryFile] = useState([]);
  // portée de l'inventaire : "all" = totalité des produits (TOTAL, choix par défaut),
  // "selection" = articles du fichier (SELECTION)
  const [inventoryScope, setInventoryScope] = useState("all");

  useEffect(() => {
    startLoading();
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setAllWarehouses(
            response.data.success.map((element) => ({
              value: element.id,
              label: element.name,
            }))
          );
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const onChangeSelectedWarehouse = (selectedOptionn) => {
    setWarehouseSelectedOption(selectedOptionn);
    setWarehouseId(selectedOptionn.value);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleNext = () => {
    // pas de loader de page ici : les requêtes POST affichent déjà l'overlay global
    if (activeStep === 0) {
      if (warehouseId === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : veuillez choisir un dépôt");
        return;
      }
      if (!inventoryFile || !inventoryFile.name) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : veuillez choisir le fichier de l'inventaire");
        return;
      }
      const uploadData = new FormData();
      uploadData.append("file", inventoryFile);
      WarehouseService.addInventaireExcel(
        getCurrentUserId(),
        warehouseId,
        uploadData,
        inventoryScope === "all" ? "TOTAL" : "SELECTION"
      )
        .then((reponse) => {
          if (reponse.data.success) {
            setInventaireWarehouse(reponse.data.success);
            setInventaireProducts(reponse.data.success?.products);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText(
              "Erreur : le fichier de l'inventaire n'a pas pu être lu"
            );
          }
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :" + error);
        });
    } else if (activeStep === 1) {
      const uploadData = new FormData();
      uploadData.append("file", inventoryFile);
      WarehouseService.validateInventaireExcel(
        getCurrentUserId(),
        warehouseId,
        uploadData,
        inventoryScope === "all" ? "TOTAL" : "SELECTION"
      )
        .then((reponse) => {
          if (reponse.data.success) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/inventaires`);
            }, 2000);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : l'inventaire n'a pas pu être validé");
          }
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :" + error);
        });
    }
  };

  const onUploadFileHandler = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setInventoryFile(file);
    }
  };

  const labelStyle = {
    fontSize: "0.8rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    color: "#6c757d",
  };
  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };

  const productsList = inventaireProducts || [];
  const surplus = productsList.reduce(
    (sum, p) => sum + Math.max(0, Number(p.ecartQuantity) || 0),
    0
  );
  const manque = productsList.reduce(
    (sum, p) => sum + Math.max(0, -(Number(p.ecartQuantity) || 0)),
    0
  );

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label style={labelStyle}>Dépôt</label>
                  <Select
                    styles={menuAboveFileStyles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    value={warehouseSelectedOption}
                    onChange={onChangeSelectedWarehouse}
                    options={allWarehouses}
                    placeholder="Choisir un dépôt..."
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label style={labelStyle}>Fichier de l'inventaire</label>
                  <label
                    htmlFor="inventaireFile"
                    className="d-block text-center mb-0"
                    style={{
                      border: `2px dashed ${
                        inventoryFile && inventoryFile.name ? "#1d6f42" : "#adb5bd"
                      }`,
                      borderRadius: 8,
                      padding: "22px 16px",
                      backgroundColor:
                        inventoryFile && inventoryFile.name ? "#f1faf5" : "#f8f9fa",
                      cursor: "pointer",
                      textTransform: "none",
                      letterSpacing: 0,
                      fontSize: "1rem",
                      color: "inherit",
                    }}
                  >
                    <i
                      className="fas fa-file-excel d-block mb-2"
                      style={{ fontSize: 34, color: "#1d6f42" }}
                    ></i>
                    <strong>
                      {inventoryFile && inventoryFile.name
                        ? inventoryFile.name
                        : "Cliquez pour choisir le fichier Excel"}
                    </strong>
                    <small className="text-muted d-block">
                      Taille maximale : 2 Mo
                    </small>
                  </label>
                  <input
                    id="inventaireFile"
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    style={{ display: "none" }}
                    onChange={onUploadFileHandler}
                  />
                </div>
              </div>
            </div>
            <div className="form-group mb-0">
              <label style={labelStyle}>Portée de l'inventaire</label>
              <div className="row">
                {[
                  {
                    value: "all",
                    title: "Totalité des produits",
                    hint: "Tous les produits du dépôt sont inventoriés ; ceux absents du fichier sont signalés comme non ajoutés.",
                    icon: "fas fa-boxes",
                  },
                  {
                    value: "selection",
                    title: "Sélection d'articles",
                    hint: "Seuls les articles présents dans le fichier sont inventoriés ; les autres ne sont pas touchés.",
                    icon: "fas fa-list-check",
                  },
                ].map((option) => {
                  const active = inventoryScope === option.value;
                  return (
                    <div className="col-md-6 mb-2" key={option.value}>
                      <label
                        htmlFor={`scope-${option.value}`}
                        className="d-flex align-items-start mb-0 h-100"
                        style={{
                          border: `2px solid ${active ? "#343a40" : "#dee2e6"}`,
                          borderRadius: 8,
                          padding: "12px 14px",
                          cursor: "pointer",
                          backgroundColor: active ? "#f8f9fa" : "#fff",
                          textTransform: "none",
                          letterSpacing: 0,
                          fontSize: "1rem",
                          color: "inherit",
                          fontWeight: "normal",
                        }}
                      >
                        <input
                          id={`scope-${option.value}`}
                          type="radio"
                          name="inventoryScope"
                          value={option.value}
                          checked={active}
                          onChange={() => setInventoryScope(option.value)}
                          className="mr-3 mt-1"
                          style={{ accentColor: "#343a40", transform: "scale(1.2)" }}
                        />
                        <span>
                          <strong>
                            <i className={`${option.icon} mr-2`}></i>
                            {option.title}
                          </strong>
                          <small className="text-muted d-block">{option.hint}</small>
                        </span>
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            {inventaireWarehouse && (
              <div className="row">
                {[
                  {
                    icon: "fas fa-warehouse",
                    label: "Dépôt",
                    value: `${inventaireWarehouse.refWarehouse}-${inventaireWarehouse.nameWarehouse}`,
                  },
                  {
                    icon: "fas fa-calendar-check",
                    label: "Date d'inventaire",
                    value: UtilsFormule.formatDate(inventaireWarehouse.creationDate),
                  },
                  {
                    icon: "fas fa-bullseye",
                    label: "Portée",
                    value:
                      inventoryScope === "all"
                        ? "Totalité des produits"
                        : "Sélection d'articles",
                  },
                  {
                    icon: "fas fa-arrow-up",
                    label: "Surplus total",
                    value: `+${surplus}`,
                  },
                  {
                    icon: "fas fa-arrow-down",
                    label: "Manque total",
                    value: `-${manque}`,
                  },
                ].map((item) => (
                  <div className="col-xl-3 col-md-6" key={item.label}>
                    <div
                      className="d-flex align-items-center p-3 mb-3 bg-white"
                      style={{ ...cardStyle, borderLeft: "4px solid #343a40" }}
                    >
                      <span
                        className="d-flex align-items-center justify-content-center bg-dark text-white mr-3"
                        style={{ width: 40, height: 40, borderRadius: 8, flexShrink: 0 }}
                      >
                        <i className={item.icon}></i>
                      </span>
                      <div style={{ minWidth: 0 }}>
                        <small
                          className="text-muted text-uppercase d-block"
                          style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                        >
                          {item.label}
                        </small>
                        <strong className="d-block text-truncate" title={item.value}>
                          {item.value}
                        </strong>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="alert alert-warning d-flex align-items-center" role="alert">
              <i className="fas fa-exclamation-triangle mr-2"></i>
              Vérifiez les produits et les quantités avant de confirmer : le stock du
              dépôt sera mis à jour.
            </div>
            {productsList.length > 0 && (
              <DataListProductDetails listProducts={productsList} />
            )}
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-clipboard-check mr-2"></i>Nouvel inventaire
              </h4>
              <small className="text-muted">
                Importez le fichier de comptage, vérifiez les écarts puis confirmez
              </small>
            </div>
            <button
              className="btn btn-outline-secondary mt-2 mt-sm-0"
              onClick={() => navigate("/inventaires")}
            >
              <i className="fas fa-arrow-left mr-1"></i>
              Retour aux inventaires
            </button>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card card-outline card-dark" style={cardStyle}>
                <div className="card-header">
                  <div className={classes.root}>
                    <Stepper activeStep={activeStep}>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>

                <div>
                  <div className="card-body">{getStepContent(activeStep)}</div>
                  <div className="card-footer d-flex justify-content-between">
                    <button
                      disabled={activeStep === 0}
                      className="btn btn-outline-secondary"
                      onClick={handleBack}
                    >
                      <i className="fas fa-arrow-left mr-1"></i>
                      Précédent
                    </button>

                    <button className="btn btn-dark" onClick={handleNext}>
                      {activeStep === steps.length - 1 ? (
                        <>
                          <i className="fas fa-check mr-1"></i>Confirmer l'inventaire
                        </>
                      ) : (
                        <>
                          Suivant<i className="fas fa-arrow-right ml-1"></i>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={3000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddInventaire);
